import React from 'react';
import Col from '@tcp/core/src/components/common/atoms/Col/views/Col';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor/views/Anchor';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GlobalActionsLabels,
  GLOBAL_ACTIONS_LABELS,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import { routerPush } from '@tcp/core/src/utils';
import { StyledBackArrow, StyledBackLabel } from '../styles/OutfitBreadcrumbs.style';
import SafeComponent from '../../../../../common/hoc/withErrorBoundary/errorBoundary';

const routesBack = (e) => {
  e.preventDefault();
  if (window.history.length > 2) window.history.back();
  else {
    routerPush('/', '/home');
  }
};

const OutfitBreadcrumbs = ({ className }) => {
  const backLabel = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_ACTIONS_LABELS}.lbl_back`,
    GlobalActionsLabels
  );
  return (
    <div>
      <Col
        colSize={{
          small: 6,
          medium: 8,
          large: 12,
        }}
        ignoreGutter={{ small: true }}
        className="outfit-back-button"
      >
        <Anchor
          fontSizeVariation="xlarge"
          anchorVariation="secondary"
          handleLinkClick={routesBack}
          noLink
          className={`${className}__backlink`}
          title={backLabel}
        >
          <StyledBackArrow />
          <StyledBackLabel>{backLabel}</StyledBackLabel>
        </Anchor>
      </Col>
    </div>
  );
};

export default SafeComponent(OutfitBreadcrumbs);
